import { useContext, createContext, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
// import requestNewAccessToken from './requestNewAccessToken';
import dataEncrpt from './Encrytho/dataEncry';
import dataDecrypt from './Encrytho/dataDescry';

const kpanel = process.env.REACT_APP_KPANEL;
const kpanelre = process.env.REACT_APP_KPANELOTHER;
const HOSTNAME = process.env.REACT_APP_HOSTNAME;
//
const QADOMIN = process.env.REACT_APP_COOK;
const NAMECOOKIEFULL = process.env.REACT_APP_NAMECOOKIEFULL;
const NAMECOOKIEFULLCH = process.env.REACT_APP_NAMECOOKIEFULLCH;
const PORTVALID = process.env.REACT_APP_PORTVALID;
const location = window.location;
const OriginQAORIG = process.env.REACT_APP_URL_QA_ORIG;

const DominSinW = process.env.REACT_APP_URL_PROD_DOMIN;
const UrlPROD = process.env.REACT_APP_URL_PROD;
const UrlAQ = process.env.REACT_APP_URL_QA;
const NAMEDOMIN = process.env.REACT_APP_NAME;


const RECAPTCHATITALCAMBIO = process.env.REACT_APP_KEY_RECAPTCHATITALCAMBIO;
const RECAPTCHATDEVLOCALHOST = process.env.REACT_APP_KEY_RECAPTCHATDEV;
const RECAPTCHATQA = process.env.REACT_APP_KEY_RECAPTCHATQA;



const AuthContext = createContext({

    isAuthenticated: false,
    Domain: false,
    KeyRecatpchat: '',
    isloading: () => { },
    setAccessTokenAndRefreshToken: () => { },
    saveUser: () => { },
    checkAuthUser: () => { },
    infoUserCheck: () => { },
    getUser: () => { },
    userClosep: () => { },
    infoUserDasboard: [],

});

export function AuthProvider({ children }) {
    //
    const [cookies, setCookie, removeCookie] = useCookies();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [Domain, setIsDomain] = useState('');
    const [KeyRecatpchat, setKEYReCAPTCHAT] = useState('');
    const [infoUserDasboard, setInfoUserDasboard] = useState(false);
    const [isloading, setIsLoading] = useState(true);

    const ExpirationDate = new Date();
    ExpirationDate.setMinutes(ExpirationDate.getMinutes() + 20); // La cookie expirará en 20 minutos

    function userClosep(userData) {

        if (location.port === PORTVALID) {

            removeCookie(
                NAMECOOKIEFULL, { path: '/', domain: 'localhost' }
            );

            checkAuth();

        } else {

            if (location.origin === OriginQAORIG) {

                removeCookie(
                    NAMECOOKIEFULL, { path: '/', domain: QADOMIN }
                );
            } else {

                removeCookie(
                    //NAMECOOKIEFULL, { path: '/', domain: "10.10.10.121" }
                    NAMECOOKIEFULL, { path: '/', domain: "italcambio.com" }
                );
            }

            checkAuth();

        }
        window.location.reload();
        return userData;
    }


    function saveUser(userData) {
        //
        setAccessTokenAndRefreshToken(userData);
        //
        return userData;
    }

    function checkAuthUser(userData) {
        //
        setCheckUserInfo(userData);
        //
        return userData;
    }

    function setAccessTokenAndRefreshToken(accessToken) {

        // Para validar si es local o producction:
        if (location.port === PORTVALID) {

            setCookie(
                NAMECOOKIEFULL,
                dataEncrpt(accessToken),
                { path: '/', domain: 'localhost', expires: ExpirationDate }
            );

            checkAuth();

        } else {


            if (location.origin === OriginQAORIG) {

                setCookie(
                    NAMECOOKIEFULL,
                    dataEncrpt(accessToken),
                    { path: '/', domain: QADOMIN, expires: ExpirationDate }
                );
            } else {

                setCookie(
                    NAMECOOKIEFULL,
                    dataEncrpt(accessToken),
                    // { path: '/', domain: "10.10.10.121", expires: ExpirationDate }
                    { path: '/', domain: "italcambio.com", expires: ExpirationDate }
                );
            }

            checkAuth();

        }

    }

    function setCheckUserInfo(accessToken) {

        // Para validar si es local o producction:
        if (location.port === PORTVALID) {

            setCookie(
                NAMECOOKIEFULLCH,
                dataEncrpt(accessToken),
                { path: '/', domain: 'localhost', expires: ExpirationDate }
            );


        } else {


            if (location.origin === OriginQAORIG) {

                setCookie(
                    NAMECOOKIEFULLCH,
                    dataEncrpt(accessToken),
                    { path: '/', domain: QADOMIN, expires: ExpirationDate }
                );
            } else {

                setCookie(
                    NAMECOOKIEFULLCH,
                    dataEncrpt(accessToken),
                    // { path: '/', domain: "10.10.10.121", expires: ExpirationDate }
                    { path: '/', domain: "italcambio.com", expires: ExpirationDate }
                );
            }


        }

    }

    // Chequea login de usuario:
    async function getNewAccessToken(refreshToken) {

        return refreshToken
    }

    // Chequea login de usuario:
    function infoUserCheck() {

        const SessionSt = dataDecrypt(cookies, true);
        return SessionSt;

    }

    async function checkAuth() {


        /// CHEQUEA EN QUE AMBIENTE ESTA PARA CONSUMIR API
        if (location.origin.includes(NAMEDOMIN)) {

            if (location.origin.includes('www.')) {

                setIsDomain(UrlPROD);
            } else {
                setIsDomain(DominSinW);
            }
            setKEYReCAPTCHAT(RECAPTCHATITALCAMBIO);
        } else {
            setIsDomain(UrlAQ);

            // VERIFICAR SI ESTA EN LOCAL ó QA y devuelte el key para ReCATPCHAT
            if (location.origin.includes(':')) { // para localhost:xxxx
                setKEYReCAPTCHAT(RECAPTCHATQA);
            } else {
                setKEYReCAPTCHAT(DominSinW);
            }
        }



        try {
            const token = dataDecrypt(cookies, false);


            if (token) {
                //
                getNewAccessToken(token)
                    .then(
                        async (newToken) => {

                            if (newToken) {

                                // console.log('DETRO', isAuthenticated)
                                // console.log('data', newToken)

                                // const POSTURL = location.hostname === HOSTNAME ? kpanelre : kpanel;
                                // window.location.href = POSTURL;

                                if (!cookies.PPDUO) {
                                    setIsAuthenticated(false);
                                    // console.log('NO HAY**********************')
                                } else {

                                    setIsAuthenticated(true);
                                    setInfoUserDasboard(newToken)
                                    // return newToken;
                                }

                            } else {
                                setIsAuthenticated(false);
                            }
                        })
                    .catch((error) => {
                        setIsAuthenticated(false);
                    });

            } else {
                //
                setIsLoading(false);
                //
            }
            //
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        checkAuth();
    }, [isAuthenticated]);


    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                isloading,
                saveUser,
                userClosep,
                checkAuthUser,
                infoUserCheck,
                infoUserDasboard,
                setAccessTokenAndRefreshToken,
                Domain,
                KeyRecatpchat,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
    // #
}

export const useAuth = () => useContext(AuthContext);
